import useFeatureFlag from 'app/ducks/featureFlags/hooks'
import { isUserInRole } from 'app/auth/utils'
import { MCP_FLAG, MCP_SETUP_ROLES } from './mcp'

// Whether to show entry points to the "Conectar assistente de IA" page: the
// `mcp_server_access` flag is on for this user, and they're an administrator
// or a manager (the backend enforces both again on every endpoint).
const useCanSetUpMcp = () => {
  const isEnabled = useFeatureFlag(MCP_FLAG)
  return isEnabled && isUserInRole(MCP_SETUP_ROLES)
}

export default useCanSetUpMcp
